import axios from "axios";

export default async function logout(){
    const res =  await axios.get("/logout");
    return res.data;
}